import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import RRuleGenerator, {
  translations,
} from "../../../../../externalDependecies/react-rrule-generator";
import { lomavisCreatorRootState } from "../../../../../pages/lomavisCreator";
import TimeField from "react-simple-timefield";
import {
  addPublicationDelay,
  addRecurringStr,
  addTime,
  clearPublishingDelayData,
  clearRecurrenceData,
  updatePublishingDelayData,
} from "../../../../../redux/slices/lomavisCreator/lomavisCreator";
import { useTranslate } from "@tolgee/react";
import { Tooltip } from "bootstrap";
import { getLanguage } from "../../../../../locales/i18n";
import { RRule, RRuleSet, rrulestr } from "rrule";
import { DayHourMinuteSelect, TimeSelect } from "../../sharedComponents";

const PublishingDelay = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();

  const [hour, setHour] = useState<number>(null);
  const [minute, setMinute] = useState<number>(null);

  const [day, setDay] = useState<number>(null);

  const [startTimeHour, setStartTimeHour] = useState<number>(null);
  const [startTimeMinute, setStartTimeMinute] = useState<number>(null);
  const [endTimeHour, setEndTimeHour] = useState<number>(null);
  const [endTimeMinute, setEndTimeMinute] = useState<number>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const [selectedDays, setSelectedDays] = useState<string[]>([]);

  const delay = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.temporaryPublishingDelayData
  );

  const allData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  const [timeInputView, setTimeInputView] = useState(false);

  const delayTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("publishing_delay_tooltip")}
              </div>
            </div></div>'`;
  const titleTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("publishing_delay_title_tooltip")}
              </div>
            </div></div>'`;
  const blockedDayTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t("blocked_days_title_tooltip")}
              </div>
            </div></div>'`;

  useEffect(() => {
    const tooltipTrigger = document.querySelector(".delay-trigger");
    const titleTooltipTrigger = document.querySelector(
      ".title-tooltip-trigger"
    );
    const blockedDaysTooltipTrigger = document.querySelector(
      ".blockedDay-trigger"
    );

    tooltipTrigger &&
      new Tooltip(tooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: delayTooltip,
      });
    blockedDaysTooltipTrigger &&
      new Tooltip(blockedDaysTooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: blockedDayTooltip,
      });
    titleTooltipTrigger &&
      new Tooltip(titleTooltipTrigger, {
        title: "title",
        placement: "auto",
        trigger: "hover",
        container: "body",
        template: titleTooltip,
      });
  }, []);

  const handleTimeChange = (day: number, hour: number, minute: number) => {
    console.log("day", day, "hour", hour, "minute", minute);
    dispatch(
      updatePublishingDelayData({
        attribute: "hours",
        value: hour,
      })
    );
    dispatch(
      updatePublishingDelayData({
        attribute: "minutes",
        value: minute,
      })
    );
    dispatch(
      updatePublishingDelayData({
        attribute: "days",
        value: day,
      })
    );

    const totalMinutes = day * 24 * 60 + hour * 60 + minute;

    dispatch(
      updatePublishingDelayData({
        attribute: "totalMinutes",
        value: totalMinutes,
      })
    );
  };

  useEffect(() => {
    setHour(delay.hours);
    setMinute(delay.minutes);
    setDay(delay.days);

    const [startHour, startMinute] = delay.noPublishStartTime
      ? delay.noPublishStartTime?.split(":").map(Number)
      : [0, 0];
    const [endHour, endMinute] = delay.noPublishEndTime
      ? delay.noPublishEndTime?.split(":").map(Number)
      : [0, 0];

    setStartTimeHour(startHour);
    setStartTimeMinute(startMinute);
    setEndTimeHour(endHour);
    setEndTimeMinute(endMinute);
  }, [delay]);

  const BlockDaysArray = [
    {
      text: t("lomavisCreator.monday"),
      value: "no-publish-mo",
    },
    {
      text: t("lomavisCreator.tuesday"),
      value: "no-publish-tu",
    },
    {
      text: t("lomavisCreator.wednesday"),
      value: "no-publish-we",
    },
    {
      text: t("lomavisCreator.thursday"),
      value: "no-publish-th",
    },
    {
      text: t("lomavisCreator.friday"),
      value: "no-publish-fr",
    },
    {
      text: t("lomavisCreator.saturday"),
      value: "no-publish-sa",
    },
    {
      text: t("lomavisCreator.sunday"),
      value: "no-publish-su",
    },
  ];
  const handleDayClick = (value: string) => {
    if (selectedDays.includes(value)) {
      // Remove the value if it is already in the array
      setSelectedDays(selectedDays.filter((day) => day !== value));
    } else {
      // Add the value if it is not already in the array
      setSelectedDays([...selectedDays, value]);
    }
    console.log(selectedDays);
  };

  useEffect(() => {
    selectedDays.length > 0 &&
      dispatch(
        updatePublishingDelayData({
          attribute: "noPublishDays",
          value: selectedDays,
        })
      );
  }, [selectedDays]);
  useEffect(() => {
    setSelectedDays(delay.noPublishDays);
  }, [delay.noPublishDays]);

  return (
    <div className="w-100 px-3 d-flex flex-column gap-5">
      <div className="d-flex flex-column gap-3">
        <h3 className="d-flex gap-1 align-items-center">
          <i
            style={{ fontSize: "18px" }}
            className="fa-duotone fa-solid fa-clock"
          ></i>
          {t("lomavisCreator.publishing_delay_head")}{" "}
          <i
            style={{ cursor: "pointer", fontSize: "16px" }}
            className="fa-duotone fa-circle-info title-tooltip-trigger "
            data-bs-toggle="tooltip"
          ></i>
        </h3>
      </div>

      <div className="form-group d-flex flex-column px-3 gap-3">
        <div className="">
          <label className="d-flex gap-1 align-items-center">
            <strong>{t("lomavisCreator.publishing_delay")}</strong>
            <i
              style={{ cursor: "pointer" }}
              className="fa-duotone fa-circle-info delay-trigger"
              data-bs-toggle="tooltip"
            ></i>
          </label>
        </div>

        <DayHourMinuteSelect
          hour={hour}
          setHour={setHour}
          minute={minute}
          setMinute={setMinute}
          day={day}
          setDay={setDay}
          onTimeChange={handleTimeChange}
          t={t}
        />
      </div>

      <div className="form-group d-flex flex-column px-3 gap-3">
        <div className="">
          <label className="d-flex gap-1 align-items-center">
            <strong>{t("lomavisCreator.publishing_delay.blockedDays")}</strong>
            <i
              style={{ cursor: "pointer" }}
              className="fa-duotone fa-circle-info blockedDay-trigger"
              data-bs-toggle="tooltip"
            ></i>
          </label>
        </div>

        <div className="d-flex flex-column gap-2">
          <div>{t("lomavisCreator.publishing_delay.blockedDays_text")}</div>

          <div className="d-flex justify-content-start flex-wrap ">
            {BlockDaysArray?.map((item, index) => (
              <div className="p-1">
                <label
                  className={`btn btn-sm btn-active-light ${
                    selectedDays?.includes(item?.value)
                      ? "btn-primary"
                      : "btn-bg-secondary"
                  }`}
                  htmlFor={`no-publish-${item.text}`}
                >
                  {item.text}
                </label>
                <input
                  type="checkbox"
                  name="no-publish-days"
                  className="btn-check"
                  id={`no-publish-${item.text}`}
                  autoComplete="off"
                  onClick={() => handleDayClick(item.value)}
                ></input>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="d-flex flex-column gap-3 px-3">
        <div>{t("lomavisCreator.publishing_delay.do_not_publish")}</div>

        <div className="d-flex gap-2 justify-content-between">
          <div className="form-group d-flex flex-column px-3 gap-3">
            <div className="">
              <label className="">{t("lomavisCreator.startTime")}</label>
            </div>

            <TimeSelect
              hour={startTimeHour}
              setHour={setStartTimeHour}
              minute={startTimeMinute}
              setMinute={setStartTimeMinute}
              onTimeChange={(hour: number, minute: number) => {
                const minutes = minute
                  ? minute.toString().padStart(2, "0")
                  : "00";
                const hours = hour ? hour.toString().padStart(2, "0") : 0;
                const value = `${hours}:${minutes}`;
                dispatch(
                  updatePublishingDelayData({
                    attribute: "noPublishStartTime",
                    value: value,
                  })
                );
              }}
            />
          </div>

          <div className="form-group d-flex flex-column px-3 gap-3">
            <div className="">
              <label className="">{t("lomavisCreator.endTime")}</label>
            </div>

            <TimeSelect
              hour={endTimeHour}
              setHour={setEndTimeHour}
              minute={endTimeMinute}
              setMinute={setEndTimeMinute}
              onTimeChange={(hour: number, minute: number) => {
                const minutes = minute
                  ? minute.toString().padStart(2, "0")
                  : "00";
                const hours = hour ? hour.toString().padStart(2, "0") : 0;
                const value = `${hours}:${minutes}`;
                dispatch(
                  updatePublishingDelayData({
                    attribute: "noPublishEndTime",
                    value: value,
                  })
                );
              }}
            />
          </div>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end text-muted p-3">
        <div
          style={{ cursor: "pointer" }}
          onClick={(event) => {
            dispatch(clearPublishingDelayData({}));
          }}
          className="px-2"
        >
          Clear
        </div>
      </div>
    </div>
  );
};

export default PublishingDelay;
